/**
 * Route for `referral-partner-program-earn-by-referring-accounts`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ReferralPartnerProgramEarnByReferringAccountsPage } from "../features/referral-partner-program-earn-by-referring-accounts/ReferralPartnerProgramEarnByReferringAccountsPage";

export const referralPartnerProgramEarnByReferringAccountsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/referral-partner-program-earn-by-referring-accounts",
	component: ReferralPartnerProgramEarnByReferringAccountsPage,
});

export default referralPartnerProgramEarnByReferringAccountsRoute;
